import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import PrinterIcon from "@redotech/redo-icons/printer.svg";
import { ExistsFilterOperator } from "@redotech/redo-views-common/advanced-filters/exists-filter";
import { ExistsTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.scanVerified;

export const ScanVerifiedFilter: ExistsTableFilter = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: ExistsFilterOperator.EXISTS,
  },
  boolDisplay: { falseDisplay: "unverified", trueDisplay: "verified" },
  Icon: PrinterIcon,
  label: "Fulfillment",
  displayName: entry.displayName,
};
